const translates: { [key: string]: { id: string } } = {
  jobsTriggersAppName: { id: 'jobs_triggers_app_name' },
  addTriggerRule: { id: 'add_trigger_rule' },
  searchByRuleName: { id: 'search_by_rule_name' },
  ruleName: { id: 'rule_name' },
  triggerJob: { id: 'trigger_job' },
  triggerJobTask: { id: 'trigger_job_task' },
  triggerType: { id: 'trigger_type' },
  triggerAction: { id: 'trigger_action' },
  triggeredJob: { id: 'triggered_job' },
  site: { id: 'site' },
  assignment: { id: 'assignment' },
  repeat: { id: 'repeat' },
  status: { id: 'status' },
  actions: { id: 'actions' },
  successfulTriggerUpdate: { id: 'successful_trigger_update' },
  failedTriggerUpdate: { id: 'failed_trigger_update' },
  successfulTriggerDuplicate: { id: 'successful_trigger_duplicate' },
  failedTriggerDuplicate: { id: 'failed_trigger_duplicate' },
  deleteTriggerConfirmationMessage: {
    id: 'delete_trigger_confirmation_message',
  },
  deleteTrigger: { id: 'delete_trigger' },
  cancel: { id: 'cancel' },
  then: { id: 'then' },
  days: { id: 'days' },
  newTriggerRule: { id: 'new_trigger_rule' },
  save: { id: 'save' },
  when: { id: 'when' },
  usingReceivedData: { id: 'using_received_data' },
  enterRuleName: { id: 'enter_rule_name' },
  additionalSettings: { id: 'additional_settings' },
  applyToSites: { id: 'apply_to_sites' },
  scheduling: { id: 'scheduling' },
  triggerStartsAt: { id: 'trigger_starts_at' },
  setAdditionalDelay: { id: 'set_additional_delay' },
  searchBySite: { id: 'search_by_site' },
  start: { id: 'start' },
  noData: { id: 'no_data' },
  never: { id: 'never' },
  daily: { id: 'daily' },
  weekly: { id: 'weekly' },
  biweekly: { id: 'biweekly' },
  monthly: { id: 'monthly' },
  custom: { id: 'custom' },
  selectJob: { id: 'select_job' },
  selectJobTask: { id: 'select_job_task' },
  stop: { id: 'stop' },
  isInProgress: { id: 'is_in_progress' },
  isCompleted: { id: 'is_completed' },
  noDelay: { id: 'no_delay' },
  nextDay: { id: 'next_day' },
  afterOneWeek: { id: 'after_one_week' },
  whenCompleted: { id: 'when_completed' },
  ruleCreationSuccess: { id: 'rule_creation_success' },
  ruleCreationFailure: { id: 'rule_creation_failure' },
  ruleExistsMessage: { id: 'rule_exists_message' },
  checkRuleNameMessage: { id: 'check_rule_name_message' },
  fillRequiredFieldsMessage: { id: 'fill_required_fields_message' },
  stopRepeat: { id: 'stop_repeat' },
  day_s: { id: 'day_s' },
  week_s: { id: 'week_s' },
  month_s: { id: 'month_s' },
  occurrence_s: { id: 'occurrence_s' },
  ruleUpdateSuccess: { id: 'rule_update_success' },
  ruleUpdateFailure: { id: 'rule_update_failure' },
  active: { id: 'active' },
  inactive: { id: 'inactive' },
  duplicate: { id: 'duplicate' },
  delete: { id: 'delete' },
  editRuleName: { id: 'edit_rule_name' },
  dueDate: { id: 'due_date' },
  dueDateIs: { id: 'due_date_is' },
  afterStartAt: { id: 'after_start_at' },
  andInputs: { id: 'and_inputs' },
  selectInputs: { id: 'select_inputs' },
  job: { id: 'job' },
  task: { id: 'task' },
  valueIs: { id: 'value_is' },
  chooseValue: { id: 'choose_value' },
  yes: { id: 'yes' },
  no: { id: 'no' },
  notSelected: { id: 'not_selected' },
  invalidTitle: { id: 'invalid_title' },
  at: { id: 'at' },
  endsAfter: { id: 'ends_after' },
  onThe: { id: 'on_the' },
  each: { id: 'each' },
  every: { id: 'every' },
  first: { id: 'first' },
  second: { id: 'second' },
  third: { id: 'third' },
  fourth: { id: 'fourth' },
  fifth: { id: 'fifth' },
  last: { id: 'last' },
  monday: { id: 'monday' },
  tuesday: { id: 'tuesday' },
  wednesday: { id: 'wednesday' },
  thursday: { id: 'thursday' },
  friday: { id: 'friday' },
  saturday: { id: 'saturday' },
  sunday: { id: 'sunday' },
  mon: { id: 'mon' },
  tue: { id: 'tue' },
  wed: { id: 'wed' },
  thu: { id: 'thu' },
  fri: { id: 'fri' },
  sat: { id: 'sat' },
  sun: { id: 'sun' },
  months: { id: 'months' },
  weeks: { id: 'weeks' },
  occurrences: { id: 'occurrences' },
  triggerTableRepeatMonthsWeek: { id: 'trigger_table_repeat_months_week' },
  triggerTableRepeatMonthsDay: { id: 'trigger_table_repeat_months_day' },
  triggerTableRepeatWeeks: { id: 'trigger_table_repeat_weeks' },
  triggerTableRepeatDays: { id: 'trigger_table_repeat_days' },
  regular: { id: 'regular' },
  siteAndUnits: { id: 'site_and_units' },
  editSiteAndUnits: { id: 'edit_site_and_units' },
  editAssignees: { id: 'edit_assignees' },
  defaultAssignees: { id: 'default_assignees' },
  triggerOptions: { id: 'trigger_options' },
  triggerRuleNamePlaceholder: { id: 'trigger_rule_name_placeholder' },
  ends: { id: 'ends' },
  after: { id: 'after' },
  seconds: { id: 'seconds' },
}

export default translates
